export default __webpack_public_path__ + "static/nude4-d3a265a23e8fdbbe4144e95496ffc85c.jpg";